const quotes = [
    "Success is the sum of small efforts, repeated day in and day out.",
    "The key to success is to focus on goals, not obstacles.",
    "Don’t stop when you're tired. Stop when you’re done.",
    "Success doesn't come from what you do occasionally, it comes from what you do consistently.",
    "The way to get started is to quit talking and begin doing.",
    "Dream big, work hard, stay focused, and make it happen.",
    "Success is not final, failure is not fatal: It is the courage to continue that counts.",
    "Action is the foundational key to all success.",
    "The harder you work for something, the greater you’ll feel when you achieve it.",
    "Success is walking from failure to failure with no loss of enthusiasm.",
    "Focus on being productive instead of busy.",
    "The only way to do great work is to love what you do.",
    "Don’t wait for opportunity. Create it.",
    "Great things never come from comfort zones.",
    "Work hard in silence, let success make the noise.",
    "Push yourself because no one else is going to do it for you.",
    "Opportunities don't happen. You create them.",
    "Believe you can and you're halfway there.",
    "The future depends on what you do today.",
    "It’s not whether you get knocked down, it’s whether you get up.",
    "Do what you can with all you have, wherever you are.",
    "If you can dream it, you can do it.",
    "Success is a journey, not a destination.",
    "Do something today that your future self will thank you for.",
    "You don’t have to be great to start, but you have to start to be great.",
    "Success is the result of preparation, hard work, and learning from failure.",
    "Small daily improvements over time lead to stunning results.",
    "The only limit to our realization of tomorrow is our doubts of today.",
    "Start where you are. Use what you have. Do what you can.",
    "Your time is limited, don’t waste it living someone else’s life.",
    "Success is the ability to go from one failure to another with no loss of enthusiasm.",
    "The harder you work, the luckier you get.",
    "The difference between who you are and who you want to be is what you do.",
    "Success is not how high you have climbed, but how you make a positive difference to the world.",
    "Discipline is the bridge between goals and accomplishment.",
    "Success doesn’t come from what you do occasionally, it comes from what you do consistently.",
    "Don’t be afraid to give up the good to go for the great.",
    "What you get by achieving your goals is not as important as what you become by achieving your goals.",
    "Everything you’ve ever wanted is on the other side of fear.",
    "Start now. Start where you are. Start with fear. Start with pain. Start with doubt. Start with hands shaking. Start with voice trembling. But start.",
    "Success is liking yourself, liking what you do, and liking how you do it.",
    "The secret of getting ahead is getting started.",
    "If you can’t fly then run, if you can’t run then walk, if you can’t walk then crawl, but whatever you do you have to keep moving forward.",
    "Success isn’t just about what you accomplish in your life, it’s about what you inspire others to do.",
    "The best time to plant a tree was 20 years ago. The second best time is now.",
    "If you want to achieve greatness stop asking for permission.",
    "Success is not in what you have, but who you are.",
    "The future belongs to those who believe in the beauty of their dreams.",
    "Success is not the key to happiness. Happiness is the key to success.",
    "Your limitation—it's only your imagination.",
    "Dream it. Wish it. Do it.",
    "Don’t stop when you’re tired, stop when you’re done.",
    "Success is a state of mind. If you want success, start thinking of yourself as a success.",
    "Don’t be busy, be productive.",
    "It’s never too late to be what you might have been.",
    "You miss 100% of the shots you don’t take.",
    "Believe in yourself and all that you are.",
    "Don’t let yesterday take up too much of today.",
    "The secret to getting ahead is getting started.",
    "If you want to go fast, go alone. If you want to go far, go together.",
    "Success is not the absence of failure; it’s the persistence through failure.",
    "Success doesn’t come from what you do occasionally, it comes from what you do consistently.",
    "You are never too old to set another goal or to dream a new dream.",
    "The only limit to your impact is your imagination and commitment.",
    "Success is the result of preparation, hard work, and learning from failure.",
    "I find that the harder I work, the more luck I seem to have.",
    "Success is the sum of small efforts, repeated day in and day out.",
    "Don’t wait for the perfect moment. Take the moment and make it perfect.",
    "Focus on the step in front of you, not the whole staircase.",
    "Success doesn’t come from what you do occasionally, it comes from what you do consistently.",
    "A goal without a plan is just a wish.",
    "Success is liking yourself, liking what you do, and liking how you do it.",
    "Success is not how high you have climbed, but how you make a positive difference to the world.",
    "The best way to predict the future is to create it.",
    "Success is not in what you have, but who you are.",
    "It’s not whether you get knocked down, it’s whether you get up.",
    "Great things never come from comfort zones.",
    "Work hard in silence, let success make the noise.",
    "Push yourself because no one else is going to do it for you.",
    "Success is the result of preparation, hard work, and learning from failure.",
    "Success is not in what you have, but who you are.",
    "The only way to do great work is to love what you do.",
    "Opportunities don’t happen, you create them.",
    "Success comes from knowing that you did your best to become the best that you are capable of becoming.",
    "Success is not just about what you accomplish in your life; it’s about what you inspire others to do.",
    "The only limit to our realization of tomorrow is our doubts of today.",
    "Success is not how high you have climbed, but how you make a positive difference to the world.",
    "It does not matter how slowly you go, as long as you do not stop.",
    "Success is not the absence of failure; it’s the persistence through failure.",
    "What seems impossible today will one day become your warm-up.",
    "Success is to be measured not so much by the position that one has reached in life as by the obstacles which he has overcome.",
    "The only way to achieve the impossible is to believe it is possible.",
    "In the middle of every difficulty lies opportunity.",
    "Success is a journey, not a destination.",
    "Nothing in the world can take the place of Persistence. Talent will not; nothing is more common than unsuccessful men with talent.",
    "Success is not how high you have climbed, but how you make a positive difference to the world.",
    "It is never too late to be what you might have been.",
    "The future depends on what you do today.",
    "Success is liking yourself, liking what you do, and liking how you do it.",
    "Success is not the key to happiness. Happiness is the key to success.",
    "Success is not final, failure is not fatal: It is the courage to continue that counts.",
    "Success is the result of preparation, hard work, and learning from failure.",
    "Success is not in what you have, but who you are.",
    "The only way to do great work is to love what you do.",
    "Opportunities don’t happen, you create them.",
    "Success comes from knowing that you did your best to become the best that you are capable of becoming.",
    "Success is not just about what you accomplish in your life; it’s about what you inspire others to do.",
    "The only limit to our realization of tomorrow is our doubts of today.",
    "Success is not how high you have climbed, but how you make a positive difference to the world.",
    "It does not matter how slowly you go, as long as you do not stop.",
    "Success is not the absence of failure; it’s the persistence through failure.",
    "What seems impossible today will one day become your warm-up."
  ];
  
  
export default quotes;
  